import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ContentSection } from './contentsection';
import {workConditionsContentSectionsPart1, workConditionsContentSectionsPart2, workConditionsContentSectionsPart3, workConditionsContentSectionsPart4, workConditionsContentSectionsPart5 } from '../constant/work-conditions-sections.constant';
import '../scss/work-condition.style.scss';
import { goodConditionImage, happyworkImage, laptopImage, laptopworkImage, officeworkImage } from './images/jpg/goodWorkconditionImage';
import { officeImage } from './images/png/icons';

const WorkConditionPageComponent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="work-condition-page px-0">
            <section className="work-condition-hero-section px-0">
                <Container>
                    <Row >
                        <Col sm={6} className='px-0'>
                            <h2 className="Heading_h1 my-3 w-100 text-start px-0 pr-sm-5">
                                {t('WHAT_ARE_GOOD_WORKING_CONDITIONS_IN_TODAYS_LABOR_MARKET')}
                            </h2>
                        </Col>
                        <Col sm={6} className='px-0'>
                            <div className="hero-description">
                                <p>{t('WORK_CONDITIONS_HERO_DESCRIPTION_PART_1')}</p>
                                <p>{t('WORK_CONDITIONS_HERO_DESCRIPTION_PART_2')}</p>
                                <p>{t('WORK_CONDITIONS_HERO_DESCRIPTION_PART_3')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container> 
            </section>

            <section className="good-hero-image-section px-0">
                <Container className="px-0">
                    <Row className='px-0'>
                        <Col className='px-2'>
                            <img src={goodConditionImage} alt="Work Conditions" className="img-fluid borderRadius-25px" />
                        </Col>
                    </Row>
                </Container>
            </section>
         
            {workConditionsContentSectionsPart1.map((section, index) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey, textIndex) => (    
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

             <section className="good-hero-image-section px-0">
                <Container className="px-0">
                    <Row className='px-0'>
                        <Col className='px-2'>
                            <img src={laptopImage} alt="Work Conditions" className="img-fluid borderRadius-25px" />
                        </Col>
                    </Row>
                </Container>
            </section>

            {workConditionsContentSectionsPart2.map((section, index) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey, textIndex) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

            <section className="good-hero-image-section px-0">
                <Container className="px-0">
                    <Row className='px-0'>
                        <Col className='px-2'>
                            <img src={officeworkImage} alt="Work Conditions" className="img-fluid borderRadius-25px" />
                        </Col>
                    </Row>
                </Container>
            </section>

            {workConditionsContentSectionsPart3.map((section, index) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey, textIndex) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}

             <section className="good-hero-image-section px-0">
                <Container className="px-0">
                    <Row className='px-0'>
                        <Col className='px-2'>
                            <img src={happyworkImage} alt="Work Conditions" className="img-fluid borderRadius-25px" />
                        </Col>
                    </Row>
                </Container>
            </section>

             {workConditionsContentSectionsPart4.map((section, index) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey, textIndex) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}
             <section className="good-hero-image-section px-0">
                <Container className="px-0">
                    <Row className='px-0'>
                        <Col className='px-2'>
                            <img src={laptopworkImage} alt="Work Conditions" className="img-fluid borderRadius-25px" />
                        </Col>
                    </Row>
                </Container>
            </section>

             {workConditionsContentSectionsPart5.map((section, index) => (
                <ContentSection key={index} title={t(section.titleKey)}>
                    <div className="text-content">
                        {section.textKeys.map((textKey, textIndex) => (
                            <p key={textIndex}>{t(textKey)}</p>
                        ))}
                    </div>
                </ContentSection>
            ))}
        </div>
    );
};

export default WorkConditionPageComponent;
